import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Home from '../components/home/Home';
import Services from '../components/services/Services';
import Skills from '../components/skills/Skills';
import Portfolio from '../components/portfolio/Portfolio';
import Resume from '../components/resume/Resume';
import Testimonials from '../components/testimonials/Testimonials';
import Pricing from '../components/pricing/Pricing';
import Blog from '../components/blog/Blog';
import Contact from '../components/contact/Contact';
import SEO from '../components/seo/SEO';
import { DEFAULT_DESCRIPTION, DEFAULT_TITLE } from '../config/seo';

export default function MainPortfolioPage() {
  const location = useLocation();

  useLayoutEffect(() => {
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [location.pathname, location.hash]);

  return (
    <>
      <SEO title={DEFAULT_TITLE} description={DEFAULT_DESCRIPTION} canonicalPath="/" ogType="website" />
      <Home />
      <Services />
      <Skills />
      <Portfolio />
      <Resume />
      <Testimonials />
      <Pricing />
      <Blog />
      <Contact />
    </>
  );
}
